import { inject, Injector, provideAppInitializer } from '@angular/core';

import { registerLocaleFactory } from './factories';

/**
 * App initializers
 */
export const APP_INITIALIZERS = [
  provideAppInitializer(() => {
    const initializerFn = registerLocaleFactory(inject(Injector));
    return initializerFn();
  }),
];
